<p [class]="isLogin ? 'login-page' : ''">
  <span>© 2020-{{ date | date: "yyyy" }} Measured All Rights Reserved</span
  ><span><span> | </span><a routerLink="/terms">Terms of Service</a></span>
</p>
